/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { SyncHealthBadge } from './SyncHealthBadge';
const meta = {
    title: 'Features/Settings/Integrations/SyncHealthBadge',
    component: SyncHealthBadge,
    parameters: {
        layout: 'padded'
    },
    decorators: [
        (Story) => (React.createElement("div", { style: { margin: '40px auto', textAlign: 'center' } },
            React.createElement(Story, null)))
    ]
};
export default meta;
export const Healthy = {
    args: { state: 'healthy', label: 'Healthy' }
};
export const Connected = {
    args: { state: 'healthy', label: 'Connected' }
};
export const AttentionNeeded = {
    args: { state: 'attention', label: 'Attention needed' }
};
